import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import AgeGate from "@/components/jd/AgeGate";
import Cursor from "@/components/jd/Cursor";
import Nav from "@/components/jd/Nav";
import Hero from "@/components/jd/Hero";
import CellarBanner from "@/components/jd/CellarBanner";
import Marquee from "@/components/jd/Marquee";
import Manifesto from "@/components/jd/Manifesto";
import TopShelf from "@/components/jd/TopShelf";
import Articles from "@/components/jd/Articles";
import Newsletter from "@/components/jd/Newsletter";
import Footer from "@/components/jd/Footer";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ShelfCategory from "@/pages/ShelfCategory";
import ArticleDetail from "@/pages/ArticleDetail";
import ReviewPage from "@/pages/ReviewPage";

function MarketingSite() {
  const rootRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div ref={rootRef} className="grain vignette bg-bg text-bone">
      <AgeGate />
      <Cursor />
      <Nav />
      <Hero />
      <CellarBanner />
      <Marquee />
      <Manifesto />
      <TopShelf />
      <Articles />
      <Newsletter />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingSite />} />
          <Route path="/shelf/:category" element={<ShelfCategory />} />
          <Route path="/journal/:slug" element={<ArticleDetail />} />
          <Route path="/review/:slug" element={<ReviewPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#17150F",
            border: "1px solid rgba(162,140,99,0.35)",
            color: "#F2EDE4",
            borderRadius: 0,
            fontFamily: "'Oswald', sans-serif",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            fontSize: "0.78rem",
          },
        }}
      />
    </div>
  );
}
